/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState:
    | { currentUser?: API.CurrentUser; permissions?: string[] }
    | undefined,
) {
  const { currentUser, permissions = [] } = initialState ?? {};
  const permSet = new Set(permissions);
  return {
    canAdmin: currentUser && currentUser.access === 'admin',
    /** 按钮级权限判断：权限码是否在当前用户的 permissions 集合中（超管后端会下发全量） */
    hasPerm: (code: string) => permSet.has(code),
  };
}
